/** @format */

import React from 'react';

export default function IconStrip({
  noOfBathrooms,
  noOfBedrooms,
  isSwimmingPool,
  dimensions
}) {
  return (
    <div className='listing-type  text2r'>
      <div className='icon-strip-container'>
        <div className='icon-strip-box'>
          <div className='icon-strip-icon icon-bedrooms '></div>
          <div className='icon-strip-text'>{noOfBedrooms} bedrooms</div>
        </div>
        <div className='icon-strip-box'>
          <div className='icon-strip-icon icon-bathrooms '></div>
          <div className='icon-strip-text '>{noOfBathrooms} bathrooms</div>
        </div>

        <div className='icon-strip-box'>
          <div className='icon-strip-icon icon-dimensions '></div>
          <div className='icon-strip-text'>{dimensions} m2</div>
        </div>

        {isSwimmingPool && (
          <div className='icon-strip-box'>
            <div className='icon-strip-icon icon-swimming-pools '></div>
            <div className='icon-strip-text'>Pool</div>
          </div>
        )}
      </div>
    </div>
  );
}
